import { Shipment } from '../models/shipment';

/**
 * This is a mutating function that should operate on a cloned shipment.  The purpose
 * is to ensure that the data is correct prior to transmitting to the server.
 *
 * @param shipment Mutable shipment data
 */
export function normalizeShipment(shipment: Shipment): Shipment {

    /* Material Date Editor sets object to be "Date" */
    if (typeof shipment.shipmentDate === 'object') {
        const obj: Date = shipment.shipmentDate;
        shipment.shipmentDate = obj.getFullYear() + '-' +
            ('0' + (obj.getMonth() + 1)).substr(-2, 2) + '-' +
            ('0' + (obj.getDate())).substr(-2, 2);
    }

    return shipment;
}
